const MINIMUM_PARTIAL_CREDIT_INCREMENT = 0.25;

interface IPartialCredit {
  partialCreditIncrement?: number;
  minimumCredit?: number;
}

export const ValidatePartialCredit = (
  t: (x: any) => string,
  values: IPartialCredit
) => {
  const errors = {} as any;
  if (
    values.partialCreditIncrement &&
    values.partialCreditIncrement < MINIMUM_PARTIAL_CREDIT_INCREMENT
  ) {
    errors.partialCreditIncrement = t({ id: "cannotBeLessThan025" });
  }

  if (
    values.minimumCredit &&
    values.minimumCredit < MINIMUM_PARTIAL_CREDIT_INCREMENT
  ) {
    errors.minimumCredit = t({ id: "cannotBeLessThan025" });
  }

  if (values.minimumCredit && !values.partialCreditIncrement) {
    errors.partialCreditIncrement = t({ id: "requiredLabel" });
  }

  if (!values.minimumCredit && values.partialCreditIncrement) {
    errors.minimumCredit = t({ id: "requiredLabel" });
  }

  if (
    values.minimumCredit &&
    values.partialCreditIncrement &&
    values.minimumCredit < values.partialCreditIncrement
  ) {
    errors.minimumCredit = t({ id: "cannotbeLessThanPartialCredits" });
  }

  return errors;
};
